import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const BrokerService = ({
  size,
  type,
  theme,
  className,
  dataTestId = "broker-service-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M1.455.727A.727.727 0 0 0 0 .727v13.091C0 15.023.977 16 2.182 16h13.09a.727.727 0 1 0 0-1.454H2.183a.727.727 0 0 1-.727-.728V.728Z" />
    <path d="M9.455 5.09c0-.4.325-.726.727-.726h3.636c.402 0 .728.325.728.727v3.636a.727.727 0 0 1-1.455 0v-1.88L9.969 9.969a.727.727 0 0 1-1.029 0L7.273 8.3 4.15 11.423a.727.727 0 0 1-1.029-1.028l3.636-3.637a.727.727 0 0 1 1.029 0l1.668 1.668 2.607-2.608h-1.88a.727.727 0 0 1-.727-.727Z" />
  </SVGIcon>
);
